/**
 * ConfigurationItem detail page -- /twin/ci/:id (P2.7.e).
 * Thin wrapper around EntityDetailLayout. CIs don't have chain
 * snapshots (chains accept entity_kind in ibs_service/service/
 * capability + blast accepts vendor); CI findings are rerouted via
 * linked_service in cascade. The chip strip is always-null here in
 * v0.2.0 and stays null even when #435 lands.
 */
import { useParams } from "react-router-dom";

import { EntityDetailLayout } from "twin/entity/EntityDetailLayout";

const NULL_CHIPS = {
  resilience: null,
  blast_ibs_count: null,
  process_count: null,
  obligation_count: null,
} as const;

export function ConfigurationItemDetail() {
  const { id } = useParams<{ id: string }>();
  return (
    <EntityDetailLayout kind="configuration_item" entityId={id} chips={NULL_CHIPS} />
  );
}
